import { Pipe, PipeTransform } from '@angular/core';
import { isset } from '@cawita/core-front';
import { CwtAssetDescriptor } from '@cawita/core-front/asset';
import { KatchaAssetService } from './asset.service';

@Pipe({
    name: 'assets'
})
export class KatchaAssetsPipe implements PipeTransform {

    constructor(private assetService: KatchaAssetService) { }

    transform(assets: CwtAssetDescriptor[] | Document[], isPrivate?: boolean, prefix?: string) {
        if (!isset(assets)) return [];
        return assets.map(asset => this.assetService.getAssetUrl(asset, isPrivate, prefix));
    }

}
